import { TSubscriptionStatus } from '@/backoffice/features/tenants/utils/subscription-status.types';
import { ChipStatus } from '@/shared/components/ui/chip/chip.types';

export const SUBSCRIPTION_STATUS_CHIP: Record<
  TSubscriptionStatus,
  { status: ChipStatus; labelKey: string }
> = {
  active: { status: 'green', labelKey: 'common:active' },
  expiringSoon: { status: 'yellow', labelKey: 'backoffice:expiring_soon' },
  expired: { status: 'red', labelKey: 'common:expired' },
  cancelled: { status: 'red', labelKey: 'common:cancelled' },
};

// Ascending sort puts the most urgent first.
export const SUBSCRIPTION_STATUS_URGENCY: Record<TSubscriptionStatus, number> =
  {
    expired: 0,
    expiringSoon: 1,
    active: 2,
    cancelled: 3,
  };
